module.exports = __webpack_public_path__ + "img/activity_ico3.9c29a23d.png";